import { css } from '@emotion/css';
import { tabStyle,repeaterPaneStyle } from 'Shared/backend/contact/ContactPage';
import { theme } from 'Shared/backend/ThemeProvider';
import { Text } from 'Shared/forms/Inputs';
import { addItemAndOpen, StoreRepeater } from 'Shared/forms/StoreRepeater';
import { Wrap } from 'Shared/forms/Wrap';

// TODO ben .tsx convert clean the handle inputs to allow users to paste in either the full url (eg facebook.com/theirPage) or the handle with @ (eg @theirPage) 

export function SocialsTab(props)
{
	let otherSocialMediaNode;

	return (
		<div class={tabStyle()}>
			<Wrap label='Facebook'>
				<Text {...props} field='facebook' placeholder='handle with no @'/>
			</Wrap>

			<Wrap label='Instagram'>
				<Text {...props} field='instagram' placeholder='handle with no @'/>
			</Wrap>

			<Wrap label='Twitter'>
				<Text {...props} field='twitter' placeholder='handle with no @' />
			</Wrap>

			<Wrap label='Tiktok'>
				<Text {...props} field='tiktok' placeholder='handle with no @' />
			</Wrap>

			<Wrap label='Snapchat' notes='your notes here'>
				<Text {...props} field='snapchat' placeholder='@handle' />
			</Wrap>

			<StoreRepeater ref={otherSocialMediaNode} {...props} page={props.page} field='otherSocialMedia' renderTitle={i => i.title}>
				{(item,index) => <OtherSocialMediaFields {...props} {...item} location={['otherSocialMedia',index]} index={index} />}
			</StoreRepeater>

			<button class={css(theme().button,{alignSelf:'start'})}
				onClick={() => addItemAndOpen({...props,permission:'edit',field:'otherSocialMedia'},otherSocialMediaNode,{})}
			>
				<i class='fas fa-plus'/> Add social media
			</button>
		</div>
	);
}


function OtherSocialMediaFields(props)
{
//TODO ask ben should we merge socials for insta fb tiktok etc into this repeater with a dropdown option and discontinue dedicated fields 

	return (
		<div class={repeaterPaneStyle()}>
			<Wrap label='Platform'>
				<Text {...props} field='title' />
			</Wrap>

			<Wrap label='Web link to the social account'
				notes='Need the full web address eg https://instagram.com/[yourPage]'
			>
				<Text {...props} field='url' />
			</Wrap>

			{/* TODO cleanse field so @ symbol isnt allowed */}
			<Wrap label='Handle @'>
				<Text {...props} field='handle' />
			</Wrap>
		</div>
	);
}
